export var PROVIDERS_API = "/gateway/api/object-resolver/providers";
export var LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';